export enum CalculationTypeEnum {
    group = 'GROUP',
    sum = 'SUM',
    avg = 'AVG',
    value = 'VALUE',
    valueForm = 'VALUE_FORM',
    lastValue = 'LAST_VALUE',
}
